import request from "../../services/request";
import { DomainConverter } from "../../utils/common";
const APPLICATION_JSON = "application/json";
export const fetchLocationDetails = async (payload: any) => {
  try {
    const queryPayloads = DomainConverter.domainToData<any>(payload);
    const response = request([
      "HOME",
      "LOCATION",
      queryPayloads || "",
      APPLICATION_JSON,
    ]);
    return response;
  } catch (err) {
    console.error("Location details : ", err);
    return null;
  }
};
